const CONTEXT_ITEM_CATEGORY_ISSUE = 'issue';
const CONTEXT_ITEM_CATEGORY_MERGE_REQUEST = 'merge_request';
const CONTEXT_ITEM_CATEGORY_FILE = 'file';
const CONTEXT_ITEM_CATEGORY_LOCAL_GIT = 'local_git';
const CONTEXT_ITEM_CATEGORY_DEPENDENCY = 'dependency';
const CONTEXT_ITEM_CATEGORY_TERMINAL_SELECTION = 'terminal';
const CONTEXT_ITEM_CATEGORY_REPOSITORY = 'repository';
const LANGUAGE_IDENTIFIER_PREFIX = 'language-';
const LANGUAGE_IDENTIFIER_DIFF = 'language-diff';
const LANGUAGE_IDENTIFIER_PLAINTEXT = 'language-plaintext';

export { CONTEXT_ITEM_CATEGORY_DEPENDENCY, CONTEXT_ITEM_CATEGORY_FILE, CONTEXT_ITEM_CATEGORY_ISSUE, CONTEXT_ITEM_CATEGORY_LOCAL_GIT, CONTEXT_ITEM_CATEGORY_MERGE_REQUEST, CONTEXT_ITEM_CATEGORY_REPOSITORY, CONTEXT_ITEM_CATEGORY_TERMINAL_SELECTION, LANGUAGE_IDENTIFIER_DIFF, LANGUAGE_IDENTIFIER_PLAINTEXT, LANGUAGE_IDENTIFIER_PREFIX };
